<!-- Filter Button (when not active) -->
@if (!isActive && config) {
<div class="filter-button" (click)="onFilterClick($event)" [class.compact]="isCompact">
  <span class="filter-label">{{ config.label }}</span>
  <mat-icon class="filter-arrow">keyboard_arrow_down</mat-icon>
  @if (isFromMoreFilters) {
  <button mat-icon-button class="remove-button" (click)="onRemoveFilter(); $event.stopPropagation()" matTooltip="Remove filter">
    <mat-icon>close</mat-icon>
  </button>
  }
</div>
}

<!-- Active Filter Display -->
@if (isActive && config) {
<div
  class="active-filter"
  [class.compact]="isCompact"
  (click)="onFilterClick($event)"
  (keydown.enter)="onFilterClick($event)"
  (keydown.space)="onFilterClick($event); $event.preventDefault()"
  tabindex="0"
  role="button"
  [attr.aria-expanded]="isDropdownOpen">
  <span class="filter-text">{{ getDisplayText() }}</span>
  <mat-icon class="filter-arrow" aria-hidden="true" [class.open]="isDropdownOpen">
    {{ isDropdownOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
  </mat-icon>
  <button mat-icon-button class="remove-button" (click)="onRemoveFilter(); $event.stopPropagation()" matTooltip="Remove filter">
    <mat-icon>close</mat-icon>
  </button>
</div>
}

<!-- Filter Dropdown -->
@if (config && isDropdownOpen) {
<div class="filter-dropdown" [class.open]="isDropdownOpen">
  <!-- Operator Selection (hidden only when there is a single operator) -->
  @if (availableOperators.length > 1) {
  <div class="operator-section">
    <button type="button" class="operator-selector" (click)="toggleOperatorOptions()" [attr.aria-expanded]="isOperatorMenuOpen">
      <span class="operator-label">{{ config.label }} {{ operatorLabels[operatorControl.value!] }}</span>
      <mat-icon class="operator-arrow">
        {{ isOperatorMenuOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </mat-icon>
    </button>

    @if (isOperatorMenuOpen) {
    <div class="operator-options">
      @for (operator of availableOperators; track operator) {
      <div class="operator-option" [class.selected]="operatorControl.value === operator" (click)="onOperatorChange(operator)">{{ config.label }} {{ operatorLabels[operator] }}</div>
      }
    </div>
    }
  </div>
  }

  <!-- Text Input (for TEXT type filters like Name/Description) -->
  @if (config.type === 'text') {
  <div class="text-input-section">
    <mat-form-field appearance="outline" class="text-input-field">
      <mat-label>{{ config.placeholder || config.label }}</mat-label>
      <input matInput [formControl]="valueControl" [placeholder]="config.placeholder" />
    </mat-form-field>
  </div>
  }

  <!-- Search Input (for filtering options) -->
  @if (config.searchable && config.type !== 'text' && config.type !== 'date' && config.type !== 'date_range') {
  <div class="search-section">
    <input type="text" class="search-input" [formControl]="searchControl" [placeholder]="config.placeholder || 'Search ' + config.label" (click)="$event.stopPropagation()" />
    <mat-icon class="search-icon">search</mat-icon>
  </div>
  }

  <!-- Date controls (PrimeNG calendar) -->
  @if (config.type === 'date' || config.type === 'date_range') {
  <div class="date-section">
    <div class="date-calendar-wrapper">
      <!-- <p-datepicker [(ngModel)]="dateModel" [selectionMode]="config.type === 'date_range' ? 'range' : 'single'" dateFormat="dd M yy" (onSelect)="onDateSelected()" [inline]="true"> </p-datepicker> -->
      <p-datepicker
        name="dateModel"
        [(ngModel)]="dateModel"
        [selectionMode]="isRangeDateOperator() ? 'range' : 'single'"
        dateFormat="dd M yy"
        (onSelect)="onDateSelected()"
        [inline]="true">
      </p-datepicker>
    </div>
  </div>
  }

  <!-- Options List (for select/multiselect) -->
  @if (config.type !== 'text' && config.type !== 'date' && config.type !== 'date_range') {
  <div class="options-section">
    @if (filteredOptions.length === 0) {
    <div class="no-options-message">
      <mat-icon>info</mat-icon>
      <span>No options available. Options will be loaded from workspace data.</span>
    </div>
    } @else {
    <div class="options-list">
      @for (option of filteredOptions; track trackByOptionId($index, option)) {
      <div class="option-item" (click)="onOptionToggle(option)">
        @if (config.multiple) {
        <mat-checkbox [checked]="isOptionSelected(option)" [disabled]="true" class="option-checkbox"> </mat-checkbox>
        } @else {
        <mat-radio-button [checked]="isOptionSelected(option)" [disabled]="true" class="option-checkbox"> </mat-radio-button>
        }

        <div class="option-content">
          @if (option.avatar || option.icon) {
          <div class="option-avatar">
            @if (option.avatar) {
            <img [src]="option.avatar" [alt]="option.label" />
            } @else if (option.icon) {
            <mat-icon>{{ option.icon }}</mat-icon>
            }
          </div>
          }

          <span class="option-label" [matTooltip]="option.label || ''" [matTooltipDisabled]="!isOptionLabelTruncated(option)">
            {{ getOptionDisplayLabel(option) }}
          </span>

          @if (option.isActive === false) {
          <span class="option-status"> (Inactive) </span>
          }
        </div>
      </div>
      }
    </div>
    }
  </div>
  }

  <!-- Dropdown Actions -->
  <div class="dropdown-actions">
    <div class="left-actions">
      @if (hasSelectedOptions && config.type !== 'text' && config.type !== 'date' && config.type !== 'date_range') {
      <button mat-button type="button" class="clear-selection-button" (click)="onClearSelection()">Clear Selection</button>
      }
    </div>
    <div class="right-actions">
      <button mat-button type="button" class="close-button" (click)="onCloseDropdown()">Close</button>
    </div>
  </div>
</div>
}
